<template>
    <section class="relative sm:py-6">
        <div v-if="showBackground" class="absolute top-0 inset-x-0 z-0">
            <div class="h-0 overflow-hidden" style="padding-bottom: calc(9/16*100%);">
                <img :src="settings.background_image" class="w-full" alt>
                <div class="absolute bottom-0 inset-x-0 overlay"></div>
            </div>
        </div>
        <div class="relative sm:max-w-sm mx-auto" :class="containerClass">
            <slot />
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        containerClass: {
            type: String,
        },
        showBackground: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            client: 'settings/getClient',
        }),
    },
    data() {
        return {
            settings: '',
        }
    },
    async mounted() {
        this.settings = await import(`@/resources/${this.client}`)
    },
}
</script>

<style scoped>
    .overlay {
        width: 100%;
        height: 100px;
    }
</style>
